module.exports = __webpack_public_path__ + "img/登记机构.5505cf26.png";